import React, { useState, useRef, useEffect } from "react";
import "../../Components/Navigation/Navigation.css";
// Import your video files
import heroVideo from "../../assets/showcase_video.mp4";
import heroVideoMobile from "../../assets/showcase_video_mobile.mp4";

const HeroVideo = () => {
    const videoRef = useRef(null);
    const [videoSrc, setVideoSrc] = useState(window.innerWidth <= 991 ? heroVideoMobile : heroVideo);

    useEffect(() => {
        const handleResize = () => {
            const newSrc = window.innerWidth <= 991 ? heroVideoMobile : heroVideo;
            if (newSrc !== videoSrc) {
                setVideoSrc(newSrc);
                if (videoRef.current) {
                    videoRef.current.load();
                }
            }
        };
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, [videoSrc]);

    return (
        <section className="hero-video-container">
            <video
                key={videoSrc} // Force re-render/reload when src changes
                ref={videoRef}
                autoPlay
                loop
                muted={true}
                playsInline
                className="background-video"
            >
                <source src={videoSrc} type="video/mp4" />
            </video>

        
        </section>
    );
};

export default HeroVideo;